const Api_Url =
  window.location.hostname === "localhost"
    ? "http://localhost:800/api/"
    : window.location.hostname === "medspa.aleaspeaks.com"
      ? "https://medspa-api.aleaspeaks.com/api/"
      : "https://api.lifeline.monetyz.com/api/"; // Add Staging Backend URL here

export { Api_Url };
